module.exports = __webpack_public_path__ + "static/img/2.f35b48e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/eng/2.png
// module id = 62+C
// module chunks = 0